import { Controller, useFormContext } from 'react-hook-form'
import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydLabel, { hookFormErrorAdapter } from '../../../../../../commonDesign/SydLabel'
import WYSIWYGEditor from '../../../../../../organisms/WYSIWYGEditor'
import SydInput from '../../../../../../commonDesign/SydInput'

const useStyles = makeStyles((theme) => ({
  markdownEditor: {
    border: '1px solid var(--color-neutral-600)',
    borderRadius: 'var(--border-radius-sm)',
    padding: theme.layout.padding.p10,
    width: '100%',
    minHeight: 'max(10vh, 120px)'
  }
}))

function WealthJourneyAttributeField ({ attribute, mappedAttributeIds }) {
  const classes = useStyles()

  const form = useFormContext()

  // Render markdown fields directly with WYSIWYGEditor
  if (attribute.type === 'markdown') {
    return (
      <Controller
        key={attribute.attributeId}
        control={form.control}
        name={attribute.accessor}
        rules={attribute.data?.validation}
        render={({ field, fieldState }) => (
          <SydLabel
            label={attribute.label}
            description={attribute.description}
            error={hookFormErrorAdapter(form, fieldState)}
          >
            <WYSIWYGEditor
              className={classes.markdownEditor}
              placeholder={attribute.placeholder ?? '...'}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              isMarkdown
              isControlled
              enableAutofocus={false}
            />
          </SydLabel>
        )}
      />
    )
  }

  // For text, title, and other simple types, use SydInput
  return (
    <Controller
      key={attribute.attributeId}
      control={form.control}
      name={attribute.accessor}
      rules={attribute.data?.validation}
      render={({ field, fieldState }) => (
        <SydLabel
          label={attribute.label}
          description={attribute.description}
          error={hookFormErrorAdapter(form, fieldState)}
        >
          <SydInput
            {...field}
            placeholder={attribute.placeholder ?? '...'}
            size='sm'
          />
        </SydLabel>
      )}
    />
  )
}

WealthJourneyAttributeField.propTypes = {
  attribute: PropTypes.object.isRequired,
  mappedAttributeIds: PropTypes.instanceOf(Set).isRequired
}

export default WealthJourneyAttributeField
